export default "__VITE_ASSET__B8FDxP9b__"